<osn-cxb-table-view
  [dataSource]="vm"
  [darkRowBackgroundFn]="darkRow"
  [disableDragAndDropTooltipMessage]="
    readonly
      ? 'Switch to draft page version to re-order tray items'
      : userSegmentId || countryId
      ? 'View all user segments and countries to re-order tray items'
      : undefined
  "
  [onRowClickFn]="onRowClick"
  [disableMoveToTop]="!accesses.screen.pageDetailScreen.reorderTray"
  [dragAndDrop]="accesses.screen.pageDetailScreen.reorderTray"
  *ngIf="pageActions$ | async as pageActions"
>
  <ng-template
    *ngIf="showLayout"
    let-tray
    osnTableViewCellProperty=".0"
    osnTableViewCellTitle="Layout"
    [osnTableViewCellSortable]="false"
    osnTableViewCellWidth="111px"
  >
    <ng-container *ngIf="castToTray(tray) as tray">
      <img
        [src]="getLayoutData(tray.layout).src"
        [alt]="getLayoutData(tray.layout).alt"
        class="layout"
        [class.gray-scaled]="!tray.visible"
      />
    </ng-container>
  </ng-template>

  <ng-template
    let-tray
    osnTableViewCellProperty=".1"
    osnTableViewCellTitle="Name"
    [osnTableViewCellSortable]="false"
    osnTableViewCellWidth="20%"
  >
    <p [class.muted]="!tray.visible" data-testid="tray-list-item-name">{{ tray.name }}</p>
  </ng-template>

  <ng-template
    *ngIf="showTrayType"
    let-tray
    osnTableViewCellProperty=".2"
    osnTableViewCellTitle="Tray type"
    [osnTableViewCellSortable]="false"
    osnTableViewCellWidth="12%"
  >
    <p [class.muted]="!tray.visible">{{ tray.trayType }}</p>
  </ng-template>

  <ng-template
    *ngIf="showCountries"
    let-tray
    osnTableViewCellProperty=".3"
    osnTableViewCellTitle="Country"
    [osnTableViewCellSortable]="false"
  >
    <ng-container *ngIf="castToTray(tray) as tray">
      <ng-container *ngIf="tray.countries | pageListTargetingTooltip : 'Country' | async as tooltipInfo">
        <p
          class="country pr-1"
          [class.muted]="!tray.visible"
          [matTooltip]="tooltipInfo.tooltip"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
        >
          <span>{{ tooltipInfo.displayedText }}</span>
        </p>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template
    *ngIf="showPlatformType && pageActions?.isPlatformEnabled"
    let-tray
    osnTableViewCellProperty=".4"
    osnTableViewCellTitle="Platforms"
    [osnTableViewCellSortable]="false"
  >
    <ng-container *ngIf="castToTray(tray) as tray">
      <ng-container *ngIf="tray.platforms | pageListTargetingTooltip : 'Platform' | async as tooltipInfo">
        <p
          class="country pr-1"
          [class.muted]="!tray.visible"
          [matTooltip]="tooltipInfo.tooltip"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
        >
          <span>{{ tooltipInfo.displayedText }}</span>
        </p>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template
    *ngIf="showUserSegments && pageActions?.isUserSegmentEnabled"
    let-tray
    osnTableViewCellProperty=".5"
    osnTableViewCellTitle="Segments"
    [osnTableViewCellSortable]="false"
  >
    <ng-container *ngIf="castToTray(tray) as tray">
      <ng-container *ngIf="tray.userSegments | pageListTargetingTooltip : 'UserSegment' | async as tooltipInfo">
        <p
          class="user-segments"
          [class.muted]="!tray.visible"
          *ngIf="tray.userSegments?.length"
          [matTooltip]="tooltipInfo.tooltip"
          matTooltipPosition="above"
          matTooltipClass="custom-tooltip"
        >
          <span>{{ tooltipInfo.displayedText }}</span>
        </p>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template
    *ngIf="showContentSource"
    let-tray
    osnTableViewCellProperty=".6"
    osnTableViewCellTitle="Content source"
    [osnTableViewCellSortable]="false"
  >
    <ng-container *ngIf="castToTray(tray) as tray">
      <ng-container *ngIf="tray.feedId && tray.feedName">
        <a (click)="$event.stopPropagation()" class="content-source" [routerLink]="'/content-groups/' + tray.feedId" target="_blank">{{
          tray.feedName
        }}</a>
      </ng-container>
      <ng-container *ngIf="tray.contentGroupPath">
        <a (click)="$event.stopPropagation()" class="content-source" [href]="[tray.contentGroupPath]" target="_blank">{{
          tray.contentGroupName
        }}</a>
      </ng-container>
      <ng-container *ngIf="!tray.feedId && !tray.contentGroupId"> <span class="text-center">-</span></ng-container>
    </ng-container>
  </ng-template>

  <ng-template
    *ngIf="showScheduling"
    let-tray
    osnTableViewCellProperty=".7"
    osnTableViewCellTitle="Scheduled"
    [osnTableViewCellSortable]="false"
  >
    <div *ngIf="!!tray.scheduledFrom" class="date-container">
      <small [class.muted]="!tray.visible" class="text-tiny-bold">From:</small>
      <span [class.muted]="!tray.visible">{{ tray.scheduledFrom | date : 'dd/MM/yyyy' }}</span>
      <span [class.muted]="!tray.visible">{{ tray.scheduledFrom | date : 'H:mm z' }}</span>
    </div>
  </ng-template>

  <ng-template *ngIf="showScheduling" let-tray osnTableViewCellProperty=".8" osnTableViewCellTitle="" [osnTableViewCellSortable]="false">
    <div *ngIf="!!tray.scheduledTo" class="date-container">
      <small [class.muted]="!tray.visible" class="text-tiny-bold">Exp:</small>
      <span [class.muted]="!tray.visible">{{ tray.scheduledTo | date : 'dd/MM/yyyy' }}</span>
      <span [class.muted]="!tray.visible">{{ tray.scheduledTo | date : 'H:mm z' }}</span>
    </div>
  </ng-template>

  <ng-template let-tray osnTableViewCellProperty=".9" osnTableViewCellTitle="" [osnTableViewCellSortable]="false">
    <ng-container *ngIf="castToTray(tray) as tray">
      <div *ngIf="!readonly" class="edit-icon-container">
        <div
          *ngIf="
            accesses.screen.pageDetailScreen.editTray ||
            accesses.screen.pageDetailScreen.hideTray ||
            accesses.screen.pageDetailScreen.deleteTray
          "
          class="menu-trigger"
          (click)="onMenuClick($event)"
          [matMenuTriggerFor]="menu"
          data-testid="tray-list-kebab-menu"
        >
          <svg-icon key="kebab" size="sm"></svg-icon>
        </div>
        <mat-menu #menu="matMenu">
          <ng-container [ngSwitch]="tray.trayType">
            <ng-container *ngSwitchCase="TrayFormViewModelType.HeroTray">
              <div
                *ngIf="accesses.screen.pageDetailScreen.editTray"
                mat-menu-item
                (click)="onTrayEditClick(tray)"
                data-testid="tray-list-edit-button"
              >
                <svg-icon key="edit" size="sm"></svg-icon>Edit tray
              </div>
              <div
                *ngIf="accesses.screen.pageDetailScreen.deleteTray"
                mat-menu-item
                (click)="onTrayDeleteClick(tray)"
                data-testid="tray-list-delete-button"
              >
                <svg-icon key="trash" size="sm"></svg-icon>Delete tray
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.AppLandingMobileTray">
              <div
                *ngIf="accesses.screen.pageDetailScreen.editTray"
                mat-menu-item
                (click)="onTrayEditClick(tray)"
                data-testid="tray-list-edit-button"
              >
                <svg-icon key="edit" size="sm"></svg-icon>Edit tray
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.AppLandingCotvTray">
              <div
                *ngIf="accesses.screen.pageDetailScreen.editTray"
                mat-menu-item
                (click)="onTrayEditClick(tray)"
                data-testid="tray-list-edit-button"
              >
                <svg-icon key="edit" size="sm"></svg-icon>Edit tray
              </div>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.TopTenTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.PortraitTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.ExpandableTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.GenreTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.StudiosTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.CollectionTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-container *ngSwitchCase="TrayFormViewModelType.SeasonTray">
              <ng-container *ngTemplateOutlet="cloneableTray"></ng-container>
            </ng-container>

            <ng-template #cloneableTray>
              <div
                *ngIf="accesses.screen.pageDetailScreen.editTray"
                mat-menu-item
                (click)="onTrayEditClick(tray)"
                data-testid="tray-list-edit-button"
              >
                <svg-icon key="edit" size="sm"></svg-icon>Edit tray
              </div>
              <div mat-menu-item (click)="onTrayCloneClick(tray)" data-testid="tray-list-clone-button">
                <svg-icon key="clone" size="sm"></svg-icon>Clone tray
              </div>
              <div
                *ngIf="accesses.screen.pageDetailScreen.hideTray"
                mat-menu-item
                (click)="onTrayVisibleChangeClick(tray.id)"
                data-testid="tray-list-hide-button"
              >
                <ng-container *ngIf="tray.visible; else hidden"><svg-icon key="eye-closed" size="sm"></svg-icon>Hide tray</ng-container>
                <ng-template #hidden><svg-icon key="eye" size="sm"></svg-icon>Show tray</ng-template>
              </div>
              <div
                *ngIf="accesses.screen.pageDetailScreen.deleteTray"
                mat-menu-item
                (click)="onTrayDeleteClick(tray)"
                data-testid="tray-list-delete-button"
              >
                <svg-icon key="trash" size="sm"></svg-icon>Delete tray
              </div>
            </ng-template>

            <ng-container *ngSwitchDefault>
              <div
                *ngIf="accesses.screen.pageDetailScreen.editTray"
                mat-menu-item
                (click)="onTrayEditClick(tray)"
                data-testid="tray-list-edit-button"
              >
                <svg-icon key="edit" size="sm"></svg-icon>Edit tray
              </div>
              <div
                *ngIf="accesses.screen.pageDetailScreen.deleteTray"
                mat-menu-item
                (click)="onTrayDeleteClick(tray)"
                data-testid="tray-list-delete-button"
              >
                <svg-icon key="trash" size="sm"></svg-icon>Delete tray
              </div>
              <div
                *ngIf="accesses.screen.pageDetailScreen.hideTray"
                mat-menu-item
                (click)="onTrayVisibleChangeClick(tray.id)"
                data-testid="tray-list-hide-button"
              >
                <ng-container *ngIf="tray.visible; else hidden"><svg-icon key="eye-closed" size="sm"></svg-icon>Hide tray</ng-container>
                <ng-template #hidden><svg-icon key="eye" size="sm"></svg-icon>Show tray</ng-template>
              </div>
            </ng-container>
          </ng-container>
        </mat-menu>
      </div>
    </ng-container>
  </ng-template>
</osn-cxb-table-view>

<ng-container *ngIf="vm.length === 0">
  <p class="loading">No trays found</p>
</ng-container>
